import React from "react";
import { useNavigate } from "react-router-dom";
import { ScrollArea, ScrollBar } from "./ui/scroll-area";

const CATEGORY_IMAGES = {
  infissi: "https://images.unsplash.com/photo-1762279938691-7effe62a77b7?w=200&h=200&fit=crop",
  porte: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop",
  cucine: "https://images.unsplash.com/photo-1722649957265-372809976610?w=200&h=200&fit=crop",
  arredamento: "https://images.unsplash.com/photo-1760611656148-063d3b9a8dbc?w=200&h=200&fit=crop",
  pergole: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=200&h=200&fit=crop",
  parquet: "https://images.unsplash.com/photo-1577030505165-4b38f69d1b1f?w=200&h=200&fit=crop",
  pavimenti: "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&h=200&fit=crop",
  outdoor: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=200&h=200&fit=crop",
};

const categories = [
  { id: "infissi", name: "Infissi" },
  { id: "porte", name: "Porte" },
  { id: "cucine", name: "Cucine" },
  { id: "arredamento", name: "Arredo" },
  { id: "pergole", name: "Pergole" },
  { id: "parquet", name: "Parquet" },
  { id: "pavimenti", name: "Pavimenti" },
  { id: "outdoor", name: "Outdoor" },
];

const Stories = ({ onCategorySelect, selectedCategory }) => {
  return (
    <div className="py-4 border-b border-white/10">
      <ScrollArea className="w-full">
        <div className="flex gap-4 px-4">
          {/* All Category */}
          <button
            onClick={() => onCategorySelect(null)}
            className="flex flex-col items-center gap-2 flex-shrink-0"
            data-testid="story-all"
          >
            <div className={`w-16 h-16 rounded-full p-0.5 ${
              !selectedCategory ? "bg-gradient-to-br from-emerald-400 to-emerald-600" : "bg-white/20"
            }`}>
              <div className="w-full h-full rounded-full bg-zinc-900 flex items-center justify-center">
                <span className="text-xl">✨</span>
              </div>
            </div>
            <span className="text-[10px] text-white/70 uppercase tracking-wider">Tutti</span>
          </button>

          {/* Category Stories */}
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategorySelect(category.id)}
              className="flex flex-col items-center gap-2 flex-shrink-0"
              data-testid={`story-${category.id}`}
            >
              <div className={`w-16 h-16 rounded-full p-0.5 transition-all duration-300 ${
                selectedCategory === category.id 
                  ? "bg-gradient-to-br from-emerald-400 to-emerald-600 scale-105" 
                  : "bg-white/20 hover:bg-white/30"
              }`}>
                <div className="w-full h-full rounded-full overflow-hidden bg-zinc-800">
                  <img
                    src={CATEGORY_IMAGES[category.id]}
                    alt={category.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-[10px] text-white/70 uppercase tracking-wider">{category.name}</span>
            </button>
          ))}
        </div>
        <ScrollBar orientation="horizontal" className="invisible" />
      </ScrollArea>
    </div>
  );
};

export default Stories;
